import axios, { AxiosResponse } from 'axios';
import queryString from 'query-string';
import { endpoints } from './utils';
import { AccessTokenData, Course } from './types';

export const baseURL = `${process.env.REACT_APP_API_BASE_URL}/api/v1`;

export const Api = axios.create({
  baseURL,
  withCredentials: false,
  // TODO: Our language setter is not working yet
  // params: { lang: 'fi_FI' },

  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const getRegistrationToken = (): Promise<AxiosResponse<AccessTokenData>> =>
  Api.post(
    endpoints.getRegistrationToken,
    queryString.stringify({
      grant_type: 'client_credentials',
      client_id: process.env.REACT_APP_API_CLIENT_ID,
      client_secret: process.env.REACT_APP_API_CLIENT_SECRET,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );

export const getClientToken = (): Promise<AxiosResponse<AccessTokenData>> =>
  Api.post(
    endpoints.getRegistrationToken,
    queryString.stringify({
      grant_type: 'client_credentials',
      client_id: process.env.REACT_APP_GET_CLIENT_ID,
      client_secret: process.env.REACT_APP_GET_CLIENT_SECRET,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );

/**
 * Get anonymous client token for public API access.
 * Uses environment-aware client selection to handle OAuth2 config differences
 * between staging and production backends.
 *
 * Staging backend: GET_CLIENT supports client_credentials, API_CLIENT fails
 * Production backend: API_CLIENT supports client_credentials, GET_CLIENT fails
 */
export const getAnonymousClientToken = (): Promise<AxiosResponse<AccessTokenData>> => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  const isStaging = baseUrl.includes('-dev.') || baseUrl.includes('staging');

  // Staging: GET_CLIENT works, API_CLIENT fails
  // Production: API_CLIENT works, GET_CLIENT fails
  if (isStaging) {
    return Api.post(
      endpoints.getRegistrationToken,
      queryString.stringify({
        grant_type: 'client_credentials',
        client_id: process.env.REACT_APP_GET_CLIENT_ID,
        client_secret: process.env.REACT_APP_GET_CLIENT_SECRET,
      }),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    );
  }

  return Api.post(
    endpoints.getRegistrationToken,
    queryString.stringify({
      grant_type: 'client_credentials',
      client_id: process.env.REACT_APP_API_CLIENT_ID,
      client_secret: process.env.REACT_APP_API_CLIENT_SECRET,
    }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
  );
};

//  client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
//   client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,

export const getAccessToken = (email: string, password: string): Promise<AxiosResponse<AccessTokenData>> =>
  Api.post(
    endpoints.getAccessToken,
    queryString.stringify({
      grant_type: 'password',
      client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
      client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
      username: email,
      password,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );

export const getCourse = (courseId: string): Promise<AxiosResponse<Course>> =>
  Api.get(endpoints.course(Number(courseId)));
